module.exports = __webpack_public_path__ + "static/image3-bd1f34ef3add8deb114a5e619095c424.jpg";